import React from "react";
import "./BackButton.css"
import classnames from "classnames";
import {useNavigate} from "react-router-dom";
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';

function BackButton({ ...props }: BackButtonProps) {
    const history = useNavigate();
    const handleBackBtn = props.onClick || (() => history(-1));
    const backButtonClasses = classnames("usa-link", props.buttonClassName);

    return (
        <div className={"relative flex top-5 gap-6 left-5"}>
            <div className="flex justify-center items-center gap-1 text-primary text-md first-letter"
                 onClick={handleBackBtn}
                 style={{cursor: "pointer"}}>
                <ArrowBackTwoToneIcon/>
                <div style={{textDecorationLine: "underline"}}>Back</div>
            </div>
        </div>
    );
}

interface BackButtonProps {
    /** Where to route the user to */
    href?: React.AnchorHTMLAttributes<HTMLAnchorElement>["href"];
    onClick?: React.MouseEventHandler;
    buttonClassName?: string;
}

export default BackButton;
